export { default as CommentIcon } from '~icons/tabler/message-circle';
